import { InstanceParameters, MethodParameters } from '@btcdirect/shared/src/types';
import { InstanceConfiguration } from '../types';

export type CallableMethods = {
    [method in GlobalMethodNames | WalletAddressMethodNames | OrderMethodNames]?: (
        params: MethodParameters,
        instanceParams?: InstanceParameters,
        configuration?: InstanceConfiguration
    ) => void;
};

export const enum GlobalMethodNames {
    LOCALE = 'locale',
    PARTNER_INFO = 'partner',
    ONE_TIME_LOGIN = 'one-time-login',
    LOGOUT = 'logout'
}

export const enum WalletAddressMethodNames {
    ADDRESSES = 'wallet-addresses',
    ADDRESS_SELECT = 'wallet-address-selected',
    ADDRESS_PROVIDE = 'wallet-address-provided'
}

export const enum OrderMethodNames {
    ADDRESS_CANCEL = 'wallet-address-confirmation-canceled',
    ADDRESS_CONFIRM = 'wallet-address-confirmation',
    ADYEN_CALLBACK = 'adyen-callback',
    C2F_ORDER_CANCEL = 'coin-to-fiat-order-canceled',
    CALLBACK = 'callback',
    CONFIRMED_ORDER = 'confirmed-order',
    CURRENCIES = 'currencies',
    F2C_ORDER_CANCEL = 'fiat-to-coin-order-canceled',
    ORDER_INFO = 'order',
    PAYMENT_METHOD = 'payment-method',
    TRANSACTION_CONFIRM = 'transaction-id-confirmation',
    SET_PARAMETERS = 'set-parameters',
    ATTEMPT_DIRECT_CONFIRM = 'attempt-direct-confirm',
    SHOW_ADDITIONAL_FEES = 'show-additional-fees',
}
